module.exports={name:"Sistema de Gestão de Contratos"};